import { CreatePostForm } from "../Components/CreatePostForm";

export const CreatePostPage = () => {
    return (
        <div>
            <CreatePostForm />
        </div>
    );
}